import segmentInitializer from './segment-initializer';

export default {
  segmentInitializer,
};
